import React from "react";
import "./styles.css";
import { ReactComponent as Instagram } from "common/assets/svg/instagram.svg";
import { ReactComponent as Twitter } from "common/assets/svg/twitter.svg";
import { ReactComponent as Linkedin } from "common/assets/svg/linkedin.svg";
import { ReactComponent as Facebook } from "common/assets/svg/fb.svg";
import { ReactComponent as MagilhubIcon } from "common/assets/svg/magilhub_logo.svg";

const DesktopFooter = () => {

  return (    
          <div className="main-merchant-footer-container">
             <div className="merchant-footer-logo-container3">
                <span className="powered-text1">Powered by</span>
                <span className="magilhub-logo1">Maghil</span>
              </div>
              <div className="policies-and-notices">
               <span onClick={() => window.open("/Support/policy", "_blank")} >Policies & Notices</span>
              </div>
           </div>
  );
};

export default DesktopFooter;
